var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.46704 7.40116V7.40116C1.94577 7.40116 1.52319 6.97858 1.52319 6.45731V5.18034M1.05127 0.738708H2.24243C4.45157 0.738708 6.24243 2.52957 6.24243 4.73871V7.40116M4.35473 7.40116H7.18628M9.07397 7.40116V7.40116C9.59524 7.40116 10.0178 6.97858 10.0178 6.45731V5.73555C10.0178 4.81565 9.2721 4.06993 8.35221 4.06993H6.24243M6.24243 1.29391V1.29391C7.69047 1.29391 9.0162 2.10597 9.67408 3.39594L10.0178 4.06993M1.52319 2.95953H3.41089",
    stroke: "#000000",
    strokeWidth: 1.1528,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDelivery);
export default __webpack_public_path__ + "static/media/home-delivery.01b78b6b7ef0386f28e426cbbe529fd1.svg";
export { ForwardRef as ReactComponent };